import { useUserStore } from '@/store/user';
import { PermissionEnum } from '@/app/core/enums/PermissionEnum';

// Drivers have no loads.search permission, so /search would bounce them to login.
export const defaultLandingPath = () =>
  useUserStore().tokenCan(PermissionEnum.LoadsSearch) ? '/search' : '/orders';
